import { useState } from 'react';
import { Skeleton } from 'antd';
import { useUpdateWorkerMutation, useUploadWorkerPhotoMutation } from 'app/services/workers';
import { useGetUnitQuery } from 'app/services/me';
import { Worker } from 'app/types/worker';
import { compressImage } from 'utils/file';
import WorkerForm, { toWorkerRequest } from './WorkerForm';

type EditWorkerProps = {
  worker: Worker;
};

const EditWorker = ({ worker }: EditWorkerProps) => {
  const { data: unit } = useGetUnitQuery({ persist: true });

  const [ updateWorker, workerMeta ] = useUpdateWorkerMutation();
  const [ uploadPhoto, photoMeta ] = useUploadWorkerPhotoMutation();
  const [ meta, setMeta ] = useState<any>({ isSuccess: false, data: {} });

  const handleSubmit = async (values: any) => {
    const fileList = values.PhotoFile as any[] | undefined;
    const photo = fileList?.[0];

    await updateWorker({
      ...toWorkerRequest(values),
      Id: worker.Id,
      RemovePhoto: !!fileList && fileList.length === 0,
    }).unwrap();

    if (photo?.originFileObj && photo.status !== 'done' && photo.status !== 'error') {
      const file = await compressImage(photo.originFileObj).catch(() => photo.originFileObj);
      // No unwrap: a failed upload doesn't undo the save, the exceptions middleware shows its toast.
      await uploadPhoto({ workerId: worker.Id, file });
    }

    setMeta({ isSuccess: true, data: { Id: worker.Id } });
  };

  if (!unit || !worker) return <Skeleton active />;

  return <WorkerForm
    handleSubmit={handleSubmit}
    worker={worker}
    unit={unit}
    meta={{
      isSuccess: meta.isSuccess,
      isLoading: workerMeta.isLoading || photoMeta.isLoading,
      isError: workerMeta.isError,
      error: workerMeta.error,
      data: meta.data
    }}
  />;
};

export default EditWorker;
